
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>
  Die Lage ist ernst:: Die Weltgesundheitsorganisation WHO hat die Ausbreitung
  des neuartigen Coronavirus als Pandemie eingestuft. Doch wie gefährlich ist
  das Virus im Vergleich zu anderen Krankheiten? Wie stark wird es sich noch
  vermehren? Um diese Fragen zu beantworten, müssen zwei Faktoren berücksichtigt
  werden: die <b>Ansteckungsgefahr</b> und die <b>Sterblichkeitsrate</b>.
  Erstere wird durch den sogenannten R0-Wert bestimmt. Er besagt, wie viele
  ­weitere Menschen ein einzelner Infizierter ansteckt.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;